import React, { useState, useEffect } from "react";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import {
  personsvg,
  carSvg,
  carSvgDark,
  saleSvg,
  paymentSvg,
  statmentSvg,
  allUsersSvg,
  twoPersonSvg,
  ticketSvg,
  logOutSvg,
  bookMark,
  heart,
  currencysvg,
  myplansvg,
} from "../../utils/data";

// Import Buyer Components
import BuyerDashboard from "../buyerProfile/BuyerDashboard";
import Profile from "../buyerProfile/Profile";
import MyBids from "../buyerProfile/MyBids";
import WonVehicles from "../buyerProfile/WonVehicles";

// Import Seller Components
import SellerDashboard from "../sellerProfile/SellerDashboard";
import SellerProfile from "../sellerProfile/Profile";
import MyVehicles from "../sellerProfile/MyVehicles";
import AddVehicles from "../sellerProfile/AddVehicles";
import Sales from "../sellerProfile/Sales";
import ProfilePayment from "../sellerProfile/ProfilePayment";
import ProfileStatement from "../sellerProfile/ProfileStatement";
import HistoryAndGatepass from "../sellerProfile/HistoryAndGatepass";
import ProfileTickets from "../sellerProfile/ProfileTickets";
import BuyerStatement from "../buyerProfile/BuyerStatement";
import BuyerSales from "../buyerProfile/BuyerSales";
import BuyerDeposit from "../buyerProfile/BuyerDeposit";
import BuyerPayment from "../buyerProfile/BuyerPayment";
import BuyerHistoryAndGatepass from "../buyerProfile/BuyerHis8toryAndGatepass";
import WishList from "../buyerProfile/WishList";
import BuyerPlans from "../buyerProfile/BuyerPlans";
import SellerPlans from "../sellerProfile/SellerPlans";
import ListingFee from "../sellerProfile/ListingFee";
import SellerInvoices from "../sellerProfile/SellerInvoices";
import SellerInvoicePayments from "../sellerProfile/SellerInvoicePayments";
import NotificationsPage from "../../pages/NotificationsPage";
import Review from "../../pages/Review";
import AddUser from "../buyerProfile/AddUser";
import AllUsers from "../buyerProfile/AllUser";
const UserMenu = () => {
  const { translate, language } = useLanguage();
  const isRTL = language === "ar";
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Active nav state
  const [active, setActive] = useState("dashboard");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Define buyer navigation items
  const buyerNavigationItems = [
    {
      key: "dashboard",
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.09966 6.51928C1.66699 7.30972 1.66699 8.26323 1.66699 10.1703V11.4378C1.66699 14.6885 1.66699 16.3139 2.6433 17.3238C3.61961 18.3337 5.19096 18.3337 8.33366 18.3337H11.667C14.8097 18.3337 16.381 18.3337 17.3573 17.3238C18.3337 16.3139 18.3337 14.6885 18.3337 11.4378V10.1703C18.3337 8.26323 18.3337 7.30972 17.901 6.51928C17.4683 5.72883 16.6779 5.23825 15.097 4.2571L13.4303 3.22272C11.7592 2.18557 10.9236 1.66699 10.0003 1.66699C9.07705 1.66699 8.24148 2.18557 6.57035 3.22272L4.90369 4.2571C3.32278 5.23825 2.53233 5.72883 2.09966 6.51928ZM7.50033 14.3753C7.15515 14.3753 6.87533 14.6551 6.87533 15.0003C6.87533 15.3455 7.15515 15.6253 7.50033 15.6253H12.5003C12.8455 15.6253 13.1253 15.3455 13.1253 15.0003C13.1253 14.6551 12.8455 14.3753 12.5003 14.3753H7.50033Z"
            fill="currentColor"
          />
        </svg>
      ),
      label: translate("dashboard.nav.dashboard"),
      route: "/dashboard",
    },
    {
      key: "profile",
      icon: personsvg,
      label: translate("dashboard.nav.profile"),
      route: "/profile",
    },
    // {
    //   key: "addUser",
    //   icon: personsvg,
    //   label: translate("dashboard.nav.addUser"),
    //   route: "/buyeruser",
    // },
    {
      key: "allbuyers",
      icon: twoPersonSvg,
      label: translate("dashboard.nav.allBuyers"),
      route: "/allbuyers",
    },
    {
      key: "myPlans",
      icon: currencysvg,
      label: translate("dashboard.nav.myPlans"),
      route: "/myplans",
    },
    {
      key: "wishList",
      icon: bookMark,
      label: translate("dashboard.nav.wishList"),
      route: "/wishlist",
    },
    {
      key: "myBids",
      icon: carSvg,
      label: translate("dashboard.nav.myBids"),
      route: "/mybids",
    },
    {
      key: "wonVehicles",
      icon: saleSvg,
      label: translate("dashboard.nav.wonVehicles"),
      route: "/wonvehicles",
    },
    {
      key: "payment",
      icon: paymentSvg,
      label: translate("dashboard.nav.payment"),
      route: "/payment",
    },

    {
      key: "historyGatePass",
      icon: statmentSvg,
      label: translate("dashboard.nav.historyGatePass"),
      route: "/historygatepass",
    },

    {
      key: "tickets",
      icon: ticketSvg,
      label: translate("dashboard.nav.tickets"),
      route: "/tickets",
    },
    {
      key: "review",
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
            fill="currentColor"
          />
        </svg>
      ),
      label: translate("dashboard.nav.review"),
      route: "/review",
    },
    {
      key: "logout",
      icon: logOutSvg,
      label: translate("dashboard.nav.logout"),
      route: "/logout",
    },
  ];

  // Define seller navigation items
  const sellerNavigationItems = [
    {
      key: "dashboard",
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.09966 6.51928C1.66699 7.30972 1.66699 8.26323 1.66699 10.1703V11.4378C1.66699 14.6885 1.66699 16.3139 2.6433 17.3238C3.61961 18.3337 5.19096 18.3337 8.33366 18.3337H11.667C14.8097 18.3337 16.381 18.3337 17.3573 17.3238C18.3337 16.3139 18.3337 14.6885 18.3337 11.4378V10.1703C18.3337 8.26323 18.3337 7.30972 17.901 6.51928C17.4683 5.72883 16.6779 5.23825 15.097 4.2571L13.4303 3.22272C11.7592 2.18557 10.9236 1.66699 10.0003 1.66699C9.07705 1.66699 8.24148 2.18557 6.57035 3.22272L4.90369 4.2571C3.32278 5.23825 2.53233 5.72883 2.09966 6.51928ZM7.50033 14.3753C7.15515 14.3753 6.87533 14.6551 6.87533 15.0003C6.87533 15.3455 7.15515 15.6253 7.50033 15.6253H12.5003C12.8455 15.6253 13.1253 15.3455 13.1253 15.0003C13.1253 14.6551 12.8455 14.3753 12.5003 14.3753H7.50033Z"
            fill="currentColor"
          />
        </svg>
      ),
      label: translate("dashboard.nav.dashboard"),
      route: "/dashboard",
    },
    {
      key: "profile",
      icon: personsvg,
      label: translate("dashboard.nav.profile"),
      route: "/profile",
    },
    //  {
    //   key: "addUser",
    //   icon: personsvg,
    //   label: translate("dashboard.nav.addUser"),
    //   route: "/buyeruser",
    // },
    {
      key: "myPlans",
      icon: currencysvg,
      label: translate("dashboard.nav.myPlans"),
      route: "/myplans",
    },
    {
      key: "myVehicles",
      icon: carSvg,
      label: translate("dashboard.nav.myVehicles"),
      route: "/myvehicles",
    },
    {
      key: "addVehicles",
      icon: carSvgDark,
      label: translate("dashboard.nav.addVehicles"),
      route: "/addvehicles",
    },
    {
      key: "payment",
      icon: paymentSvg,
      label: translate("dashboard.nav.payment"),
      route: "/payment",
    },
    {
      key: "listingFee",
      icon: currencysvg,
      label: translate("dashboard.nav.listingFee"),
      route: "/listingfee",
    },
    {
      key: "withdrawal_requests",
      icon: statmentSvg,
      label: translate("dashboard.nav.withdrawal_requests"),
      route: "/withdrawalrequests",
    },
    {
      key: "invoices",
      icon: statmentSvg,
      label: translate("dashboard.nav.invoices"),
      route: "/invoices",
    },

    // {
    //   key: "statement",
    //   icon: statmentSvg,
    //   label: translate("dashboard.nav.statement"),
    //   route: "/statement",
    // },
    {
      key: "historyGatePass",
      icon: statmentSvg,
      label: translate("dashboard.nav.historyGatePass"),
      route: "/historygatepass",
    },
    {
      key: "tickets",
      icon: ticketSvg,
      label: translate("dashboard.nav.tickets"),
      route: "/tickets",
    },
    {
      key: "review",
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
            fill="currentColor"
          />
        </svg>
      ),
      label: translate("dashboard.nav.review"),
      route: "/review",
    },

    {
      key: "logout",
      icon: logOutSvg,
      label: translate("dashboard.nav.logout"),
      route: "/logout",
    },
  ];

  // Select navigation items based on userType
  const navigationItems = (() => {
    if (user?.userType === "buyer") {
      let items = buyerNavigationItems;
      const isChildBuyer = !!user?.buyer?.parentId;

      // Show 'addUser' 'allUser only to corporate buyers (buyerTypeId === 2)
      if (user?.buyer?.buyerTypeId !== 2) {
        items = items.filter(
          (item) => !["addUser", "allbuyers"].includes(item.key),
        );
      }

      // Hide 'myPlans', 'addUser', 'allbuyers' for child buyers
      if (isChildBuyer) {
        items = items.filter(
          (item) => !["addUser", "allbuyers", "myPlans"].includes(item.key),
        );
      }

      return items;
    } else if (user?.userType === "seller") {
      // Filter out addVehicles if seller is not approved
      if (user?.seller?.isApproved === false) {
        return sellerNavigationItems.filter(
          (item) => item.key !== "addVehicles",
        );
      }
      // Ensure sellers never see addUser
      return sellerNavigationItems.filter((item) => item.key !== "addUser");
    }
    return [];
  })();

  // Function to render the appropriate component based on userType and active navigation
  const renderActiveComponent = () => {
    if (!user) return null;

    if (user.userType === "buyer") {
      switch (active) {
        case "dashboard":
          return <BuyerDashboard />;
        case "addUser":
          return <AddUser />;
        case "profile":
          return <Profile />;
        case "allbuyers":
          return <AllUsers />;
        case "myPlans":
          return <BuyerPlans />;
        case "myBids":
          return <MyBids />;
        case "wonVehicles":
          return <WonVehicles />;
        case "sales":
          return <BuyerSales />;
        case "deposit":
          return <BuyerDeposit />;
        case "payment":
          return <BuyerPayment />;
        case "statement":
          return <BuyerStatement />;
        case "historyGatePass":
          return <BuyerHistoryAndGatepass />;
        case "tickets":
          return <ProfileTickets />;
        case "wishList":
          return <WishList />;
        case "review":
          return <Review />;
        case "notifications":
          return <NotificationsPage />;

        default:
          return <BuyerDashboard />;
      }
    } else if (user.userType === "seller") {
      switch (active) {
        case "dashboard":
          return <Sales />;
        case "profile":
          return <SellerProfile />;
        case "myVehicles":
          return <MyVehicles />;
        case "addVehicles":
          return <AddVehicles />;
        case "myPlans":
          return <SellerPlans />;
        case "listingFee":
          return <ListingFee />;
        case "payment":
          return <ProfilePayment />;
        case "withdrawal_requests":
          return <SellerInvoices />;
        case "invoices":
          return <SellerInvoicePayments />;
        case "historyGatePass":
          // return <HistoryAndGatepass />;
          return <BuyerHistoryAndGatepass />;
        case "tickets":
          return <ProfileTickets />;
        case "review":
          return <Review />;
        case "notifications":
          return <NotificationsPage />;
        default:
          return <SellerDashboard />;
      }
    }
    return null;
  };

  // Sync active state with current route
  useEffect(() => {
    const currentPath = location.pathname;

    // Handle sub-routes for profile
    if (currentPath.startsWith("/profile")) {
      setActive("profile");
      return;
    }

    // Special handling for notifications page
    if (currentPath === "/notifications") {
      setActive("notifications");
      return;
    }

    // Special handling for add/edit user routes (all render AddUser component)
    if (
      currentPath === "/adduser" ||
      currentPath.startsWith("/edituser/") ||
      currentPath.startsWith("/buyeruser")
    ) {
      setActive("addUser");
      return;
    }

    // Find navigation item that matches current route
    const currentItem = navigationItems.find(
      (item) => item.route === currentPath,
    );

    if (currentItem) {
      setActive(currentItem.key);
    } else if (currentPath === "/dashboard" || currentPath === "/") {
      setActive("dashboard");
    } else {
      // Default to dashboard for any unmatched routes
      setActive("dashboard");
    }
  }, [location.pathname, navigationItems]);

  const formatLabel = (label) =>
    typeof label === "string"
      ? label
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/^./, (str) => str.toUpperCase())
      : ""; // Return empty string if not a string

  // Function to get user type label (Individual/Corporate)
  const getUserTypeLabel = () => {
    if (!user) return translate("dashboard.userType.user");

    // Check for buyer type
    if (user.userType === "buyer") {
      if (user.buyer?.parentId) return translate("dashboard.userType.childBuyer");

      const buyerTypeId = user.buyer?.buyerTypeId;
      if (buyerTypeId === 1) return translate("dashboard.userType.individual");
      if (buyerTypeId === 2) return translate("dashboard.userType.corporate");
    }

    // Check for seller type
    if (user.userType === "seller") {
      const sellerTypeId = user.seller?.sellerTypeId;
      if (sellerTypeId === 1) return translate("dashboard.userType.individual");
      if (sellerTypeId === 2) return translate("dashboard.userType.corporate");
    }

    return translate("dashboard.userType.user");
  };

  const handleNavigationClick = (key) => {
    if (key === "logout") {
      logout();
    } else {
      setActive(key);
      const item = navigationItems.find((navItem) => navItem.key === key);
      if (item && item.route) {
        navigate(item.route);
      }
    }
    // Close mobile menu on navigation
    setIsMobileMenuOpen(false);
  };

  // Render menu items function (reusable for desktop and mobile)
  const renderMenuItems = (className = "") => (
    <div className={`space-y-2 ${className}`}>
      {navigationItems.map((item) => {
        const isActive = active === item.key;
        return (
          <div
            key={item.key}
            onClick={() => handleNavigationClick(item.key)}
            className={`flex items-center gap-3 px-4 py-3 rounded-lg cursor-pointer transition-all duration-200 text-sm ${isActive
              ? "bg-gradient-to-r from-primary to-secondary font-semibold text-white shadow-lg"
              : "text-white hover:bg-primary hover:text-gray-900"
              }`}
            style={
              (item.key === "myPlans" ||
                item.key === "statement" ||
                item.key === "wonVehicles") &&
                user?.userType === "buyer"
                ? {
                  borderBottomWidth: "1px",
                  borderBottomStyle: "solid",
                  borderImageSlice: 1,
                  borderImageSource:
                    "linear-gradient(90deg, rgba(19, 19, 19, 0) 0%, rgba(19, 19, 19, 0.5) 50%, rgba(19, 19, 19, 0) 100%)",
                  borderImageOutset: 0,
                  borderImageRepeat: "stretch",
                }
                : (item.key === "profile" || item.key === "addVehicles") &&
                  user?.userType === "seller"
                  ? {
                    borderBottomWidth: "1px",
                    borderBottomStyle: "solid",
                    borderImageSlice: 1,
                    borderImageSource:
                      "linear-gradient(90deg, rgba(19, 19, 19, 0) 0%, rgba(19, 19, 19, 0.5) 50%, rgba(19, 19, 19, 0) 100%)",
                    borderImageOutset: 0,
                    borderImageRepeat: "stretch",
                  }
                  : {}
            }
          >
            {/* Icon */}
            <span
              className={`w-5 h-5 flex-shrink-0 ${isActive ? "text-white" : "text-white"
                }`}
            >
              {item.icon}
            </span>
            {/* Label */}
            <span className={`${isActive ? "text-white" : "text-white"}`}>
              {formatLabel(item.label)}
            </span>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className="flex min-h-screen max-w-7xl mx-auto mt-5 mb-4 relative">
      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        className="md:hidden absolute top-0 left-4 z-50 bg-white p-3 rounded-lg shadow-lg border border-gray-200 hover:bg-gray-50 transition-colors"
      >
        {isMobileMenuOpen ? (
          <X className="w-5 h-5 text-gray-700" />
        ) : (
          <Menu className="w-5 h-5 text-gray-700" />
        )}
      </button>

      {/* Mobile Sidebar Overlay */}
      {isMobileMenuOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
      )}

      {/* Mobile Sidebar */}
      <div
        className={`md:hidden fixed left-0 top-0 h-full w-[280px] bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out overflow-y-auto ${isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
          }`}
      >
        <nav className="p-4 pt-4">
          {/* Dashboard Header */}
          <div className="mb-4 -mx-4 -mt-4">
            <div className="relative bg-gradient-to-r from-primary via-secondary to-primary p-4 rounded-t-xl">
              {/* Background Pattern */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-1 right-3 w-12 h-12 bg-white rounded-full opacity-20"></div>
                <div className="absolute bottom-1 left-3 w-8 h-8 bg-white rounded-full opacity-15"></div>
                <div className="absolute top-1/2 right-6 w-4 h-4 bg-white rounded-full opacity-25"></div>
              </div>

              {/* Header Content */}
              <div className="relative z-10">
                <div className="flex items-center justify-between mb-1">
                  <div className="flex items-center gap-2">
                    {/* Dashboard Icon */}
                    <div className="w-6 h-6 bg-white bg-opacity-20 rounded-md flex items-center justify-center">
                      <svg
                        className="w-4 h-4 text-white"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                      </svg>
                    </div>

                    <div>
                      <h1 className="text-base font-bold text-white leading-tight">
                        {user?.userType === "seller"
                          ? translate("dashboard.sellerDashboard")
                          : translate("dashboard.buyerDashboard")}
                      </h1>
                      <p className="text-white text-opacity-80 text-xs leading-tight">
                        {translate("dashboard.welcomeBack")}{" "}
                        {user?.userType === "seller"
                          ? translate("dashboard.vehiclesAndSales")
                          : translate("dashboard.bidsAndPurchases")}
                      </p>
                      {user?.clientId && (
                        <p className="text-white text-opacity-80 text-xs leading-tight">
                          {user.clientId}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* User Type Badge */}
                  <span className="px-2 py-1 bg-white bg-opacity-20 rounded-full text-xs font-medium text-white uppercase tracking-wide">
                    {getUserTypeLabel()}
                  </span>
                </div>
              </div>
            </div>

            {/* Bottom border with shadow */}
            <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
          </div>
          {renderMenuItems()}
        </nav>
      </div>

      {/* Navigation Sidebar - Hidden on mobile */}
      <div className="hidden md:block sm:w-[200px] w-full md:w-[280px] lg:w-[320px] rounded-xl shadow-lg">
        <nav className="p-4 pt-0">
          {/* Dashboard Header */}
          <div className="mb-4 -mx-4 -mt-0">
            <div className="relative bg-gradient-to-r from-primary via-secondary to-primary p-4 rounded-t-xl">
              {/* Background Pattern */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-1 right-3 w-12 h-12 bg-white rounded-full opacity-20"></div>
                <div className="absolute bottom-1 left-3 w-8 h-8 bg-white rounded-full opacity-15"></div>
                <div className="absolute top-1/2 right-6 w-4 h-4 bg-white rounded-full opacity-25"></div>
              </div>

              {/* Header Content */}
              <div className="relative z-10">
                <div className="flex items-center justify-between mb-1">
                  <div className="flex items-center gap-2">
                    {/* Dashboard Icon */}
                    <div className="w-6 h-6 bg-white bg-opacity-20 rounded-md flex items-center justify-center">
                      <svg
                        className="w-4 h-4 text-white"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                      </svg>
                    </div>

                    <div>
                      <h1 className="text-lg font-bold text-white leading-tight">
                        {user?.userType === "seller"
                          ? translate("dashboard.sellerDashboard")
                          : translate("dashboard.buyerDashboard")}
                      </h1>
                      <p className="text-white text-opacity-80 text-xs leading-tight">
                        {translate("dashboard.welcomeBack")}{" "}
                        {user?.userType === "seller"
                          ? translate("dashboard.vehiclesAndSales")
                          : translate("dashboard.bidsAndPurchases")}
                      </p>
                      {user?.clientId && (
                        <p className="text-white font-bold mt-2 text-opacity-80 text-sm ">
                          {user.clientId}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* User Type Badge */}
                  <span className="px-2 py-1 bg-white bg-opacity-20 rounded-full text-xs font-medium text-white uppercase tracking-wide">
                    {getUserTypeLabel()}
                  </span>
                </div>
              </div>
            </div>

            {/* Bottom border with shadow */}
            <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
          </div>
          {renderMenuItems()}
        </nav>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 pt-16 md:pt-0 p-4 md:p-6 md:ml-0 ml-0">
        {renderActiveComponent()}
      </div>
    </div>
  );
};

export default UserMenu;
